import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function WarningIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} width="33" height="31" viewBox="0 0 33 31" fill="none">
      <path
        d="M16.5002 17.4539V11.7034"
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4987 22.0746C16.2865 22.0746 16.1143 22.2468 16.1158 22.459C16.1158 22.6712 16.2881 22.8434 16.5002 22.8434C16.7124 22.8434 16.8846 22.6712 16.8846 22.459C16.8846 22.2468 16.7124 22.0746 16.4987 22.0746"
        stroke="currentColor"
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6202 3.64503L31.3965 24.2547C32.7649 26.6503 31.0352 29.6316 28.2767 29.6316H4.72411C1.96415 29.6316 0.234377 26.6503 1.60436 24.2547L13.3807 3.64503C14.7599 1.22949 18.241 1.22949 19.6202 3.64503Z"
        stroke="currentColor"
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
